import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MessageCircle } from "lucide-react";
import Logo from "@/components/Logo";

export default function Footer() {
    return (
        <footer className="relative z-10 border-t border-white/10 bg-[#0A0A0A]">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
                <div className="md:col-span-5">
                    <Logo />
                    <p className="mt-6 text-white/60 text-sm max-w-sm leading-relaxed">
                        Personal branding & lead generation for Dubai's real estate elite.
                        9+ years of building brands that convert.
                    </p>
                </div>

                <div className="md:col-span-3">
                    <div className="eyebrow mb-4">Explore</div>
                    <ul className="space-y-3 text-sm">
                        <li><a href="/#services" className="text-white/80 hover:text-brand transition-colors">Services</a></li>
                        <li><a href="/#packages" className="text-white/80 hover:text-brand transition-colors">Packages</a></li>
                        <li><a href="/#faq" className="text-white/80 hover:text-brand transition-colors">FAQs</a></li>
                        <li><Link to="/terms" className="text-white/80 hover:text-brand transition-colors">Terms & Conditions</Link></li>
                        <li><Link to="/admin" className="text-white/40 hover:text-brand transition-colors text-xs">Admin</Link></li>
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <div className="eyebrow mb-4">Contact</div>
                    <ul className="space-y-3 text-sm">
                        <li>
                            <a href="mailto:baburali514@gmail.com" className="flex items-center gap-3 text-white/80 hover:text-brand transition-colors">
                                <Mail className="w-4 h-4" /> baburali514@gmail.com
                            </a>
                        </li>
                        <li>
                            <a href="tel:+971543676278" className="flex items-center gap-3 text-white/80 hover:text-brand transition-colors">
                                <Phone className="w-4 h-4" /> +971 54 367 6278
                            </a>
                        </li>
                        <li>
                            <a href="https://instagram.com/growwithbabur" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white/80 hover:text-brand transition-colors">
                                <Instagram className="w-4 h-4" /> @growwithbabur
                            </a>
                        </li>
                        <li>
                            <a href="https://wa.me/971543676278" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white/80 hover:text-brand transition-colors">
                                <MessageCircle className="w-4 h-4" /> WhatsApp
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/40 font-mono">
                    <div>© {new Date().getFullYear()} Grow With Babur. All rights reserved.</div>
                    <div>Dubai, United Arab Emirates</div>
                </div>
            </div>
        </footer>
    );
}
